import React, { useState } from 'react';
import { ExternalLinkIcon, MapIcon } from 'lucide-react';
type LazyMapProps = {
  title: string;
  embedUrl: string;
  mapsUrl: string;
  className?: string;
};
export function LazyMap({
  title,
  embedUrl,
  mapsUrl,
  className = ''
}: LazyMapProps) {
  const [isLoaded, setIsLoaded] = useState(false);
  if (isLoaded) {
    return <div className={`relative overflow-hidden ${className}`} data-id="element-338" data-mp="2kn9b8b9rcrr3">
        <iframe title={title} src={embedUrl} className="h-full w-full grayscale-[0.1]" loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-id="element-339" data-mp="2pjzq4v9tthax" />
        <a href={mapsUrl} target="_blank" rel="noreferrer" className="absolute right-4 top-4 inline-flex items-center gap-2 rounded-full bg-white/95 px-3 py-2 text-xs font-semibold text-royal shadow-glass transition-colors hover:bg-white" data-id="element-340" data-mp="2zkjva90gv5yf">
          Open in Maps <ExternalLinkIcon className="h-3.5 w-3.5" data-id="element-341" data-mp="197ko9jwi7sqa" />
        </a>
      </div>;
  }
  return <div className={`relative flex items-center justify-center overflow-hidden bg-sky ${className}`} data-id="element-342" data-mp="uhqswix0sykk">
      <div className="absolute inset-0 bg-[linear-gradient(135deg,rgba(45,168,255,0.18),transparent_55%,rgba(0,87,255,0.12))]" data-id="element-343" data-mp="ponyk8kf5l3b" />
      <div className="relative z-10 flex max-w-sm flex-col items-center px-6 text-center" data-id="element-344" data-mp="kot4jw5ckfe1">
        <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white text-royal shadow-glass" data-id="element-345" data-mp="fpyfwdkp7wm0">
          <MapIcon className="h-6 w-6" data-id="element-346" data-mp="18gqgdn8sr7f5" />
        </span>
        <p className="mt-4 font-display text-lg font-bold text-navy" data-id="element-347" data-mp="18h9okc8nahfz">
          Explore our Houston service area
        </p>
        <p className="mt-2 text-sm leading-relaxed text-slate" data-id="element-348" data-mp="13jq9xb81c2ni">
          The interactive map loads only when you choose to view it.
        </p>
        <div className="mt-5 flex flex-wrap justify-center gap-3" data-id="element-349" data-mp="3o84kzofamgp3">
          <button type="button" onClick={() => setIsLoaded(true)} className="rounded-full bg-royal px-5 py-3 text-sm font-semibold text-white shadow-glow transition-transform hover:scale-[1.02] focus:outline-none focus:ring-4 focus:ring-royal/20" data-id="element-350" data-mp="3j8rmg6f27l6o">
            Load interactive map
          </button>
          <a href={mapsUrl} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full border border-royal/20 bg-white/80 px-5 py-3 text-sm font-semibold text-royal transition-colors hover:bg-white" data-id="element-351" data-mp="21ad6df9087t5">
            Open in Maps <ExternalLinkIcon className="h-4 w-4" data-id="element-352" data-mp="1wcv8cjwizczx" />
          </a>
        </div>
      </div>
    </div>;
}